"use client";

import { useEffect, useState } from "react";

/**
 * Cycles an index 0..length-1 on an interval, for rotating-word UI (e.g. the
 * rolling provider name in the video input placeholder). Pauses on demand and
 * freezes entirely under prefers-reduced-motion.
 */
export function useRollingIndex(
  length: number,
  intervalMs: number,
  paused: boolean
) {
  const [index, setIndex] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(mediaQuery.matches);
    update();
    mediaQuery.addEventListener?.("change", update);
    return () => mediaQuery.removeEventListener?.("change", update);
  }, []);

  useEffect(() => {
    if (paused || reducedMotion || length <= 1) return;
    const id = setInterval(
      () => setIndex((current) => (current + 1) % length),
      intervalMs
    );
    return () => clearInterval(id);
  }, [paused, reducedMotion, length, intervalMs]);

  return { index, reducedMotion };
}
